import CommonService from "../services/common.service";

// globalFunctions.js
export const globalFunction = (setShowPointModal, setGradeList) => {
  CommonService.getGradeList().then((res) => {
    setShowPointModal(true);
    setGradeList(res.data);
  });
};
